import { FilterGroup } from 'components/Filters/components/FilterModal'
import { SelectFilter } from 'components/Filters/fields/SelectFilter'
import { FilterStore } from 'components/Filters/FilterStore'
import useApiService from 'services/api'
import { createFilterColumnHelper } from '../commonColumnHelpers'
import { COMMON_COLUMNS } from '../CommonColumnsInfo'
import { RangeFilter } from 'components/Filters/fields/RangeFilter'

type CommonAccountGroupProps = {
  filterStore: FilterStore
  campaignOptions?: any
  hideCampaignsFilter?: boolean
}

/**
 * Hook variant that returns the Account-group filter elements as a Fragment
 * (no FilterGroup wrapper). Useful for sortable filtersets that need the
 * filters to be direct React.Children so FilterModal's alphabetical walker
 * can extract each one's title and bucket it by first letter.
 */
export function useCommonAccountGroupFilters({
  filterStore,
  campaignOptions,
  hideCampaignsFilter: hideCampaigns,
}: CommonAccountGroupProps) {
  const api = useApiService()
  const { data: stageOptions } = api.useGetSalesStageOptions(true)
  const { data: userOptions } = api.useGetUserOptions({
    onlyActive: true,
    withNoneOption: true,
  })
  const { data: tagsOptions } = api.useGetTagsOptions(true)
  const { data: distributorOptions } =
    api.useGetCompanyDistributorsOptions(true)
  const { data: gpoOptions } = api.useGetCompanyGPOsOptions(true)
  const commonFilterHelper = createFilterColumnHelper({
    columns: COMMON_COLUMNS,
  })

  return (
    <>
      {campaignOptions && !hideCampaigns && (
        <SelectFilter
          {...commonFilterHelper.retrieveProps('campaigns')}
          options={campaignOptions as any}
          filterStore={filterStore}
        />
      )}
      <SelectFilter
        {...commonFilterHelper.retrieveProps('sales_stages')}
        options={stageOptions as any}
        filterStore={filterStore}
      />
      <SelectFilter
        {...commonFilterHelper.retrieveProps('account_owners')}
        options={userOptions as any}
        filterStore={filterStore}
      />
      <SelectFilter
        {...commonFilterHelper.retrieveProps('taglist')}
        options={tagsOptions as any}
        filterStore={filterStore}
      />
      <RangeFilter
        {...commonFilterHelper.retrieveProps('deal_count')}
        store={filterStore}
      />
      <RangeFilter
        {...commonFilterHelper.retrieveProps('note_count')}
        store={filterStore}
      />
      <RangeFilter
        {...commonFilterHelper.retrieveProps('contact_count')}
        store={filterStore}
      />
      <SelectFilter
        {...commonFilterHelper.retrieveProps('distributors')}
        filterStore={filterStore}
        options={distributorOptions as any}
      />
      <SelectFilter
        {...commonFilterHelper.retrieveProps('gpos')}
        filterStore={filterStore}
        options={gpoOptions as any}
      />
    </>
  )
}

export function CommonFiltersetAccountGroup(props: CommonAccountGroupProps) {
  const filters = useCommonAccountGroupFilters(props)
  return <FilterGroup title="Account">{filters}</FilterGroup>
}
